import styles from "../../styles/AboutUs.module.css"
import mobile from "../../assets/nib.jpg"
import dash from "../../assets/ventur.jpg"
import report from "../../assets/yaya1.jpg"
import about from "../../assets/release.jpg"
import Ejat from "../../assets/E-jit.jpg"
import pcidss from "../../assets/pcidssAward.png"
import arifSwitch from "../../assets/ArifSwitch.png"
import arifSchoolPartnership from "../../assets/ArifSchoolPartnership.jpg"
import redCloud from "../../assets/recloud.png"
import micro from "../../assets/micro.jpg"
import visa from "../../assets/visa.jpg"
import avicom from "../../assets/avicom.jpg"
import remit from "../../assets/Arifremit.jpg"
import yango from "../../assets/yango.jpg"


const PressReleasesSection = () => {
  return (
    <div className={styles.pressReleasesSection} style={{ overflowX: "hidden" }}>
      <h2 className={styles.pressReleasesTitle}>Press Releases</h2>
      <div className={styles.pressReleasesGrid} style={{ overflowX: "hidden" }}>

        <div className={styles.pressReleaseCard} style={{ overflowX: "hidden" }}>
          <img
            src={arifSchoolPartnership}
            alt="Arifpay and partners launch ArifSchool"
            className={styles.pressReleaseImage}
          />
          <p className={styles.pressReleaseReport}>Report</p>
          <h3 className={styles.pressReleaseHeadline}>
            Arifpay, in partnership with Gebeya, AIT, and EducationMatters, has officially launched ArifSchool, a comprehensive digital education ecosystem designed to modernize and transform Ethiopia's education sector.
          </h3>
        </div>

        <div className={styles.pressReleaseCard} style={{ overflowX: "hidden" }}>
          <img
            src={remit}
            alt="The new update on our pos machine integration for you"
            className={styles.pressReleaseImage}
          />
          <p className={styles.pressReleaseReport}>Report</p>
          <h3 className={styles.pressReleaseHeadline}>
Arif Remit is now officially launched in Virginia, USA. The service was proudly introduced at the Grand African Run in front of thousands of Ethiopians.
          </h3>
        </div>


         <div className={styles.pressReleaseCard} style={{ overflowX: "hidden" }}>
          <img
            src={yango || "/placeholder.svg"}
            alt="The New realse of Arifpay dashbord"
            className={styles.pressReleaseImage}
          />
          <p className={styles.pressReleaseReport}>Report</p>
          <h3 className={styles.pressReleaseHeadline}>
      Arifpay has partnered with Yango Ethiopia. To bring smarter, faster, and seamless payments to the ride-hailing experience.
           
          </h3>
        </div>


           <div className={styles.pressReleaseCard} style={{ overflowX: "hidden" }}>
          <img
            src={micro || "/placeholder.svg"}
            alt="The New realse of Arifpay dashbord"
            className={styles.pressReleaseImage}
          />
          <p className={styles.pressReleaseReport}>Report</p>
          <h3 className={styles.pressReleaseHeadline}>
         The First Microfinance Summit powered by Arifpay and ETIFT wrapped up with powerful insights on how digital systems can strengthen Ethiopia’s microfinance sector.
           
          </h3>
        </div>
        <div className={styles.pressReleaseCard} style={{ overflowX: "hidden" }}>
          <img
            src={visa}
            alt="The new update on our pos machine integration for you"
            className={styles.pressReleaseImage}
          />
          <p className={styles.pressReleaseReport}>Report</p>
          <h3 className={styles.pressReleaseHeadline}>
          Arifpay has partnered with Visa to deploy 10,000 POS terminals across Ethiopia, bringing interoperable payments to SMEs nationwide.
          
          </h3>
        </div>
     
     

   
      </div>
      <button className={styles.readMoreButton}>
        <a href="/PressRelease" style={{ textDecoration: "none", color: "inherit" }}>
          Read More →
        </a>
      </button>
    </div>
  )
}

export default PressReleasesSection